import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useHierarchiesStore = defineStore('hierarchies', {
  state,
  getters,
  actions
})

export default useHierarchiesStore
